/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "copy-9b6242e0--sprite",
  "use": "copy-9b6242e0--sprite-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\" id=\"copy-9b6242e0--sprite\"><path d=\"M.5.5h11v1H.5v-1z\" fill=\"#fff\" stroke=\"#11171C\" /><path d=\"M1.5.5v13h-1V.5h1z\" fill=\"#fff\" stroke=\"#11171C\" /><path stroke=\"#11171C\" stroke-width=\"2\" d=\"M5 5h10v12H5z\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
